export default __webpack_public_path__ + "static/media/floor-8.bb8d3be8.jpg";